window.addEventListener('load', function () {
  const _learnq = window._learnq || [];

  let klAjax = true;

  const atcButtons = document.querySelectorAll(
    "form[action*='/cart/add'] button[type='submit']",
  );

  for (let i = 0; i < atcButtons.length; i++) {
    atcButtons[i].addEventListener('click', function () {
      const form = this.closest('form');

      const trackItem = {
        Name: form.querySelector('input[name="title"]').value,
        ProductID: form.querySelector('input[name*="id"]').value,
      };

      if (klAjax) {
        _learnq.push(['track', 'Added to Cart', trackItem]);
        klAjax = false;
      }
    });
  }
});
